<template>
    <main-layout class="bouteille-single">

        <app-header icon="bottle">
            Bouteille
        </app-header>

        <action-bar :back="{ name: 'liste-bouteilles' }">

            <a v-if="!this.isRestit && this.bouteille.actif === true" class="btn add btn-full main-action cloturer"
                href="javascript: void 0" @click="modifBouteilleStatus">
                <i class="icon-go"></i>
                <span>
                    <strong>Clôturer</strong><br> la bouteille
                </span>
            </a>
            <a v-if="!this.isRestit && this.bouteille.actif === false" class="btn add btn-full main-action rendre"
                href="javascript: void 0" @click="modifBouteilleStatus">
                <i class="icon-go"></i>
                <span>
                    <strong>Rendre</strong><br> la bouteille
                </span>
            </a>
        </action-bar>

        <div id="bouteille">

            <p v-if="this.isRestit">Bouteille restituée.</p>

            <div class="topbouteille wrap" v-if="bouteille.type" :class="shortTypeName">

                <p
                    v-if="this.bouteille.favori !== null && this.bouteille.favori != undefined && this.bouteille.favori.id === $user.id">
                    <i class="icon-star" style="color: #f9d342"></i>
                </p>

                <p id="typebouteille">{{ shortTypeName }}</p>
                <p>
                    Bouteille
                    <span id="nombouteille" v-if="bouteille.nom">{{ bouteille.nom.nom }}</span>
                    <span id="poidsmax" data-max="10">({{ bouteille.poids_max }}Kg)</span>
                    <br>
                    <span id="distributeur" v-if="bouteille.fournisseur">{{ bouteille.fournisseur.nom }}</span>
                    <span id="marque" v-if="bouteille.marque"><template v-if="bouteille.fournisseur">· </template>{{ bouteille.marque }}</span>
                </p>
            </div>

            <div class="mainbouteille wrap">

                <div class="left">

                    <div class="btn btn-full codebouteille" v-if="bouteille.type" :class="shortTypeName">
                        <i class="icon-gas"></i>
                        <p id="codebouteille">{{ bouteille.code }}</p>
                    </div>

                    <div class="btn btn-full fluide" :class="bouteille.fluide.regenerated ? 'regen' : ''"
                        v-if="bouteille.fluide">
                        <i class="icon-fluid"></i>
                        <p id="nomfluide">{{ bouteille.fluide.nom }}</p>
                    </div>

                    <div class="btn btn-full otag" v-if="bouteille.otag">
                        <i class="icon-otag"></i>
                        <p id="otag">{{ bouteille.otag }}</p>
                    </div>

                    <a v-if="!this.isRestit && this.bouteille.actif === true && this.bouteille.otag === null"
                        class="btn btn-full otag" :href="`fi360://scan?success=tryGoTo&bouteille=${bouteille.id}`">
                        <i class="icon-otag"></i>
                        <p><strong>Ajouter une otag</strong></p>
                    </a>

                    <div class="block-cloture" v-if="bouteille.actif === false">
                        <strong>BOUTEILLE CLOTURÉE</strong>
                    </div>

                    <div v-if="bouteille.tare">
                        <p>Tare : <strong>{{ (bouteille.tare).toFixed(2) }} Kg</strong></p>
                        <p>Tare + net : <strong> {{ getPoidsBrut(bouteille.tare, bouteille.poids_net) }} Kg</strong></p>
                    </div>

                    <div class="calendar">
                        <i class="icon-calend"></i>
                        <p>
                            Retour prévu
                            <br>
                            <strong>
                                <span id="dateretour">{{ bouteille.date_retour_prevue | dateFormat }}</span>
                            </strong>
                        </p>
                        <div class="clear"></div>
                    </div>

                    <div v-if="bouteille.ref_livraison !== null" class="calendar">
                        <i class="icon-marquage"></i>
                        <p>
                            Référence livraison
                            <br>
                            <strong>
                                <span id="reference">{{ refLivraisonTruncate }}</span>
                            </strong>
                        </p>
                        <div class="clear"></div>
                    </div>

                    <a v-if="bouteille.otag !== null" href="javascript: void 0" class="btn localisation"
                        @click.prevent="toggleMap">
                        <i class="icon-geoloc"></i>
                        <strong>LOCALISER</strong>
                        LA BOUTEILLE
                    </a>

                    <div id="showMap" style="opacity: 0">
                        <div id="displayMap" ref="displayMap"></div>
                    </div>

                    <a v-if="historiques.length !== 0" class="btn localisation" @click.prevent="toggleHistoryUser()">
                        <i class="icon-users"></i>
                        <strong>Historique</strong>
                    </a>

                    <div id="showHistoryUser" style="display: none">
                        <div class="histo" v-for="histo in historiques" :key="histo.id">
                            <span class="user">Par {{ histo.user }}</span>
                            <span class="date">le {{ histo.date | dateFormat }}</span>
                            <div class="clear"></div>
                        </div>
                    </div>

                    <a v-if="bouteille.type === 'Fluide frigorigène' && bouteille.actif === true"
                        href="javascript: void 0" class="btn localisation" @click.prevent="goToRegul">
                        <i class="icon-tools"></i>
                        <span>Régulariser</span>
                    </a>

                    <div class="btn btn-full favori" @click="addThisBottleToFavorite"
                        v-if="!this.bouteille.favori || (this.bouteille.favori && this.bouteille.favori.id !== this.$user.id)">
                        <i class="icon-star"></i>
                        <span style="font-size: 14px">Ajouter aux favoris</span>
                    </div>

                    <div class="btn btn-full favori" @click="removeThisBottleToFavorite" v-else>
                        <i class="icon-star"></i>
                        <span style="font-size: 14px">Retirer des favoris</span>
                    </div>

                    <div class="btn btn-full favori" @click="affecterFavori" v-if="isMagasinier() && !isRestit">
                        <i class="icon-star"></i>
                        <span style="font-size: 14px">
                            Affecter le favori
                            <template v-if="bouteille.favori && bouteille.favori.id">
                                <br><small>{{ bouteille.favori.last_name }} {{ bouteille.favori.first_name }}</small>
                            </template>
                        </span>
                    </div>

                </div>

                <div class="right">
                    <div id="levelbouteille">
                        <i class="icon-bottle"></i>
                        <span id="fill" :style="computedHeight">
                            <i class="icon-bottle filling"></i>
                        </span>
                        <span id="indicators" :style="computedHeight">
                            <div class="triangle"></div>
                            <div class="level">
                                <p>
                                    <span id="levelfill" data-fill="6">{{ bouteille.poids_net }}</span> kg
                                </p>
                            </div>
                        </span>
                    </div>
                    <div
                        v-if="bouteille.poids_net > 0 && operations.length > 0 && infoManip(operations[0].id_type) === 'déchet' && (bouteille.type === 'Transfert' || bouteille.type === 'Récupération')">
                        <span style="font-size: 12px;">Fluide pour traitement</span>
                    </div>
                    <div
                        v-if="bouteille.poids_net > 0 && operations.length > 0 && infoManip(operations[0].id_type) !== 'déchet' && (bouteille.type === 'Transfert' || bouteille.type === 'Récupération')">
                        <span style="font-size: 12px;">Fluide recyclé pour réintroduction</span>
                    </div>
                </div>

                <div class="clear"></div>

            </div>

            <div class="operations wrap">

                <a class="btn-op btn history" id="toggle-history" href="javascript: void 0"
                    @click.prevent="toggleHistory">
                    <i class="icon-link"></i>
                    HISTORIQUE<br>
                    <strong>BOUTEILLE</strong>
                </a>

                <div v-if="operations.length > 0">

                    <div class="histo" v-for="op in operations" :key="op.id" v-show="showHistory"
                        :class="getOpClass(op.type)">
                        <span class="quantite">{{ op.quantite }}Kg <span class="manip-label">{{
                                infoManip(op.id_type) }}<template v-if="op.fluideNom"> · {{ op.fluideNom }}</template></span></span>
                        <span class="user" v-if="op.user">{{ op.user }}</span>
                        <span class="date">{{ op.date | dateFormat }}</span>
                        <div class="clear"></div>
                    </div>

                </div>
            </div>
        </div>

    </main-layout>
</template>

<script>

import User from "@/js/models/User";
import Synchro from '../../js/core/Synchro';
import Bouteille from '../../js/models/Bouteille';
import OperationBouteille from '../../js/models/OperationBouteille';
import Scan from "../../js/models/Scan";

export default {

    data() {

        return {
            bouteille: {},
            operations: [],
            scan: null,
            showHistory: true,
            usrScan: null,
            dateScan: null,
            historiques: [],
        }

    },

    methods: {

        addThisBottleToFavorite() {

            // favori absent sur une bouteille créée hors ligne, {id: null} après un retrait
            const userFavoriWithThisBottle = this.bouteille.favori && this.bouteille.favori.id ? this.bouteille.favori : null;

            User.getUserData(user => {
                const sameUser = userFavoriWithThisBottle !== null && userFavoriWithThisBottle.id === user.id;

                const getFullName = (u) => `${u.last_name} ${u.first_name}`;

                const confirmAndUpdate = () => this.enregistrerFavori(
                    { id: user.id, first_name: user.first_name, last_name: user.last_name },
                    'La bouteille a bien été ajoutée à vos favoris'
                );

                if (userFavoriWithThisBottle !== null) {
                    if (sameUser) {
                        return swal({
                            title: 'Bouteille favorite',
                            text: 'Cette bouteille est déjà dans vos favoris',
                            type: 'info',
                            showCancelButton: false,
                            confirmButtonText: 'Ok',
                        });
                    } else {
                        return swal({
                            title: 'Bouteille favorite',
                            html: `Cette bouteille est la bouteille favorite de <strong>${getFullName(userFavoriWithThisBottle)}</strong>. Voulez-vous la mettre dans vos favoris ? <br>Cela retirera la bouteille de ces favoris.`,
                            type: 'question',
                            showCancelButton: true,
                            confirmButtonText: 'Oui',
                            cancelButtonText: 'Non',
                        }).then(res => {
                            if (res === true) confirmAndUpdate();
                        });
                    }
                }

                return swal({
                    title: 'Bouteille favorite',
                    text: 'Voulez-vous ajouter cette bouteille à vos favoris ?',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Non',
                }).then(res => {
                    if (res === true) confirmAndUpdate();
                });
            });

        },

        removeThisBottleToFavorite() {

            User.getUserData(user => {
                if (user.id === this.bouteille.favori.id) {
                    return swal({
                        title: 'Bouteille favorite',
                        html: `Voulez-vous retirer cette bouteille de vos favoris ?`,
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Oui',
                        cancelButtonText: 'Non',
                    }).then(res => {
                        if (res === true) {
                            this.enregistrerFavori({ id: null }, 'La bouteille a bien été retirée de vos favoris');
                        }
                    });
                }
            });
        },

        // Méthode et non computed : $user (Vue.prototype) n'est pas réactif, un computed resterait figé.
        isMagasinier() {
            return !!this.$user && this.$user.type === 'magasinier';
        },

        affecterFavori() {
            localforage.getItem('listUsers').then(usrs => {
                const utilisateurs = JSON.parse(usrs) || [];
                const techniciens = utilisateurs
                    .filter(usr => usr.id === this.$user.id || usr.favori_selectionnable === true)
                    .sort((a, b) => `${a.last_name} ${a.first_name}`.localeCompare(`${b.last_name} ${b.first_name}`, 'fr', { sensitivity: 'base' }));

                if (!utilisateurs.some(usr => usr.hasOwnProperty('favori_selectionnable'))) {
                    return swal('Bouteille favorite', 'Synchronisez l\'application pour charger la liste des techniciens.', 'info');
                }

                const favori = this.bouteille.favori && this.bouteille.favori.id ? this.bouteille.favori : null;

                // Clés préfixées : des clés numériques seraient réordonnées par id dans le select.
                const inputOptions = { aucun: 'Aucun' };
                // Un favori hors liste (autre magasinier, technicien désactivé…) reste proposé :
                // sinon le select afficherait « Aucun » et valider le supprimerait.
                if (favori && !techniciens.some(usr => usr.id === favori.id)) {
                    inputOptions[`u${favori.id}`] = `${favori.last_name} ${favori.first_name}`;
                }
                techniciens.forEach(usr => {
                    inputOptions[`u${usr.id}`] = `${usr.last_name} ${usr.first_name}`;
                });

                const valeurActuelle = favori ? `u${favori.id}` : 'aucun';

                swal({
                    title: 'Bouteille favorite',
                    text: 'Affecter cette bouteille en favori à :',
                    input: 'select',
                    inputOptions: inputOptions,
                    inputValue: valeurActuelle,
                    showCancelButton: true,
                    confirmButtonText: 'Valider',
                    cancelButtonText: 'Annuler',
                }).then(value => {
                    if (value === valeurActuelle) {
                        return;
                    }

                    const usr = techniciens.find(u => `u${u.id}` === value);

                    this.enregistrerFavori(
                        usr ? { id: usr.id, first_name: usr.first_name, last_name: usr.last_name } : { id: null },
                        'Le favori de la bouteille a été enregistré, il sera transmis à la prochaine synchronisation'
                    );
                }, () => {
                });
            });
        },

        enregistrerFavori(favori, messageSucces) {
            const bout = Object.assign({}, this.bouteille, { favori: favori, favori_modifie: true });

            return Bouteille.updateBouteille(bout.id, bout)
                .then(() => {
                    // Le marqueur ne vit que dans le cache, que la synchro remet à zéro : resté sur
                    // l'objet affiché, il serait réécrit par une action ultérieure (clôture…).
                    this.bouteille = Object.assign({}, this.bouteille, { favori: favori });
                    swal('Bouteille favorite', messageSucces, 'success');
                })
                .catch(() => swal('Bouteille favorite', 'Le favori n\'a pas pu être enregistré, réessayez.', 'error'));
        },

        fetchBouteilleData() {

            return new Promise((resolve, reject) => {

                let idBout = this.$route.params.id;

                Bouteille
                    .getBouteille(idBout)
                    .then(data => {
                        this.bouteille = data;
                        resolve(data)
                    })
                    .catch(err => reject(err))

            })

        },

        fetchHistoriqueBouteille() {
            let idBout = this.$route.params.id;
            Bouteille
                .getAllScanByBouteilles(idBout)
                .then(scans => {
                    this.historiques = scans
                })

        },

        fetchOperations() {

            let op = new OperationBouteille;
            let idBout = this.$route.params.id;
            op.getOpsForBouteille(idBout)
                .then(data => op.addFluideNom(data))
                .then(data => {
                    this.operations = data
                })

        },

        infoManip(id) {
            if (id === 1) {
                return 'vierge'
            } else if (id === 2) {
                return 'recyclé'
            } else if (id === 3) {
                return 'régénéré'
            } else if (id === 4) {
                return 'déchet'
            } else if (id === 5) {
                return 'réutilisation'
            } else if (id === 6) {
                return 'régul'
            } else if (id === 7) {
                return 'regul'
            } else {
                return 'N/A'
            }
        },

        fetchScans() {

            Scan
                .getLastScanForBouteille(this.$route.params.id)
                .then(res => {
                    if (res !== undefined) {

                        this.scan = res;
                        this.dateScan = moment(res.created_at).format('DD/MM/YY HH:mm');

                        localforage.getItem('listUsers').then(usrs => {
                            let lstUsrs = JSON.parse(usrs);

                            if (res.user) {
                                this.usrScan = lstUsrs.filter(usr => {
                                    if (usr.id === res.user.id) {
                                        return usr
                                    }
                                })


                            } else {
                                this.usrScan = [{ nom: '' }]
                            }

                        })

                    }
                })
                .catch()

        },

        getOpClass(type) {
            let back = '';
            let inverse = _.includes(type.toLowerCase(), 'régularisation');

            if (_.includes(type.toLowerCase(), 'ajout')) {
                back = inverse ? 'add regul' : 'remove'
            } else {
                back = inverse ? 'remove regul' : 'add'
            }

            return back;
        },

        getPoidsBrut(val1, val2) {
            return (val1 + val2).toFixed(2)
        },

        async modifBouteilleStatus() {
            let idB = this.$route.params.id;
            if (!_.includes(idB, 'N-')) {
                idB = parseInt(idB)
            }

            if (this.bouteille.actif) {
                let isReutilisable = await Bouteille.isReutilisable(idB);

                if (isReutilisable === true) {
                    return swal('Fluide pour réutilisation', 'Attention Bouteille contenant du Fluide pour <strong>réutilisation</strong>.<br> Elle ne peut être rendue en l\'état sur <strong>TRACKDECHETS</strong>. Contactez la personne qui gère F.i360° dans votre entreprise avant de rendre cette bouteille.', 'info');
                }
                Bouteille.close(idB, this.bouteille)

            } else {
                let test = await Bouteille.isRendable(idB);
                let isReutilisable = await Bouteille.isReutilisable(idB);
                let isFluidFrigo = await Bouteille.isFluidFrigo(idB);
                let checkTdProblem = await Bouteille.checkTdProblem(idB);


                if (checkTdProblem.length > 0) {
                    let htmlMsg = "Le(s) détenteur(s) : <br><ul>";

                    checkTdProblem.forEach(detName => {
                        htmlMsg += "<li>" + detName + "</li>";
                    });

                    htmlMsg += "</ul> ne sont pas conforme à TrackDéchets. <br><br>Contactez la personne qui gère F.i360° dans votre entreprise avant de rendre cette bouteille.";

                    return swal({
                        title: 'Erreur',
                        html: htmlMsg,
                        type: 'error',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: "Ok",
                        confirmButtonText: "Ok"
                    }).catch(function (err) {
                        if (err == "cancel") {
                            if (navigator.onLine) {
                                Synchro.syncDetenteurs();
                            }
                        }
                    })
                }

                if (this.bouteille.poids_net == 0) {
                    //Force en frigo si la bouteille est vide, parce que osef, pas de transporteur, pas de td...
                    isFluidFrigo = true;
                }

                if (isReutilisable === false && isFluidFrigo === false && (localStorage.getItem('activateTrackDechets') === 'true')) {
                    let detenteurIsOk = await Bouteille.getDetenteurIsOk(idB);

                    if (detenteurIsOk.isOk === false) {

                        let htmlMsg = "Le(s) détenteur(s) : <br><ul>";

                        detenteurIsOk.detNom.forEach(detName => {
                            htmlMsg += "<li>" + detName + "</li>";
                        });

                        htmlMsg += "</ul> ne sont pas conforme à TrackDéchets. <br><br>Contactez la personne qui gère F.i360° dans votre entreprise avant de rendre cette bouteille.";

                        return swal({
                            title: 'Erreur',
                            html: htmlMsg,
                            type: 'error',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: "Ok",
                            confirmButtonText: "Ok"
                        }).catch(function (err) {
                            if (err == "cancel") {
                                if (navigator.onLine) {
                                    Synchro.syncDetenteurs();
                                }
                            }
                        })
                    }
                }

                if (test === true) {

                    Bouteille
                        .restitution([idB], isReutilisable, isFluidFrigo)
                        .then(() => {
                            this.$router.push({ name: 'home' });
                            swal('Bouteille restituée', 'La bouteille a bien été rendue', 'success')
                        })
                        .catch(() => {})

                } else {
                    swal('Intervention en cours', 'Cette bouteille contient au moins une opération sur une fiche non clôturée, elle ne peut donc pas être rendue pour le moment', 'warning')

                }

            }
        },

        toggleHistoryUser() {
            let showHistoryUser = document.getElementById('showHistoryUser');
            showHistoryUser.style.display = (showHistoryUser.style.display === 'none') ? 'block' : 'none';
        },

        toggleMap() {
            if (this.scan !== null) {
                let showMap = document.getElementById('showMap');
                let displayMap = document.getElementById('displayMap');
                showMap.style.opacity = 1;

                displayMap.style.height = '210px';
                displayMap.style.width = '360px';
                displayMap.style.marginBottom = '10px';
                this.loadMap();
            } else {
                return swal('Aucun scan disponible', "", 'info')
            }
        },

        loadMap() {
            if (this.carte) {
                this.carte.invalidateSize();
                return;
            }

            if (this.scan !== null) {
                //this.showMap = true;

                const lat = this.scan.lat;
                const lng = this.scan.lng;

                let codeBout = this.bouteille.code;
                let dateBout = this.dateScan;

                let usrScan;
                if (!this.usrScan[0].nom) {
                    usrScan = ''
                } else {
                    usrScan = 'Par ' + this.usrScan[0].nom;
                }




                let mapEl = document.getElementById('displayMap');

                let map = L.map(mapEl, {
                    center: [lat, lng],
                    zoom: 19,
                    zoomControl: false,
                })

                map.invalidateSize();

                let layer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                });

                map.addLayer(layer);

                let contentString =
                    `<div id="content" style="overflow:hidden" >
                            <div id="siteNotice">
                            </div>
                            <h1 id="firstHeading" class="firstHeading" style="font-size:15px; font-weight:bold; margin-bottom:15px">Bouteille code : ${codeBout}</h1>
                            <div id="bodyContent">
                                <p>
                                    Scan : ${dateBout}  <br/>
                                    ${usrScan}
                                </p>
                            </div>
                        </div>`;

                delete L.Icon.Default.prototype._getIconUrl;
                L.Icon.Default.mergeOptions({
                    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
                    iconUrl: require("leaflet/dist/images/marker-icon.png"),
                    shadowUrl: require("leaflet/dist/images/marker-shadow.png")
                });

                let marker = L.marker([lat, lng], {
                    html: contentString
                }).addTo(map);

                map.setView([lat, lng]);
                this.carte = map;

                marker.bindPopup(contentString, {
                    className: 'custom-popup'
                })



            } else {
                swal('Aucun scan disponible', "", 'info')
            }


        },

        toggleHistory() {
            this.showHistory = (!this.showHistory);
        },

        goToRegul() {
            swal({
                title: 'Information',
                html: 'Si vous avez confondu <strong>Poids BRUT</strong> et <strong>Poids NET</strong>,<br>Ne pas utiliser ce bouton.<br><br>La correction se fait depuis l\'interface FI360 en modifiant le poids initial de fluide.',
                type: 'info',
                showCancelButton: false,
                confirmButtonText: 'Compris',
            }).then(() => {
                this.$router.push({ name: 'bouteille-regul', params: { id: this.bouteille.id } });
            });
        }

    },

    computed: {

        shortTypeName: function () {
            let type = this.bouteille.type;

            return type.substring(0, 1).toLowerCase()
        },

        computedHeight: function () {
            let ratio = 200 * this.bouteille.poids_net / this.bouteille.poids_max;
            return 'height : ' + ratio + 'px;'
        },

        refLivraisonTruncate() {
            if (typeof this.bouteille.ref_livraison != "undefined") {
                if (this.bouteille.ref_livraison === null) {
                    return null;
                } else if (this.bouteille.ref_livraison.length > 25) {
                    return this.bouteille.ref_livraison.substring(0, 25) + '...';
                } else {
                    return this.bouteille.ref_livraison;
                }
            }

            return null;

        },

        isRestit() {
            if (!this.bouteille.actif && this.bouteille.restitution) {
                return true
            }
        }

    },

    mounted: function () {

        this
            .fetchBouteilleData()
            .then(data => {
                if (this.$route.query.scan) {
                    Scan.addOfflineScanBouteille(data.id).catch(() => {})
                }
                if (this.$route.query.addOtag) {
                    swal('Bouteille modifiée', 'La bouteille a bien été modifiée', 'success');
                }

            })
            .catch();

        this.fetchOperations();

        this.fetchScans();

        if (navigator.onLine) {
            //this.fetchHistoriqueBouteille();
        }

    },

    beforeDestroy() {
        if (this.carte) {
            this.carte.remove();
            this.carte = null;
        }
    },
}

</script>

<style>
@import '~leaflet/dist/leaflet.css';
</style>

<style scoped>
#bouteille .mainbouteille #levelbouteille>span#indicators .level {
    position: absolute;
    top: -35px;
    height: 10px;
    display: block;
    width: auto;
    margin-top: 10px;
    border-radius: 5px;
}

.histo {
    border-left: 4px solid #fff;
}

.histo.regul {
    border-left-color: #f58e28;
}

#codebouteille {
    font-size: min(3.5vw, 1.8rem);

}

.favori {
    display: inline-flex;               /* alignement propre */
    align-items: center;
    gap: .6em;                          /* espace icône/texte */
    background: #f1c40f;
    color: #222;
    font-weight: 600;
    font-size: clamp(13px, 3.5vw, 15px);/* taille fluide */
    line-height: 1;                     /* évite la "bave" verticalement */
    white-space: nowrap;                /* pas de retour à la ligne */
    padding: .7em 1.1em;                /* padding adaptatif */
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0,0,0,.15);
    transition: background-color .3s;   /* pas de transform par défaut (mobile) */
    max-width: 100%;                    /* pas de débordement */
    text-align: center;
    margin-right: 10px;
}
</style>




// WEBPACK FOOTER //
// Bouteille.vue?503c286a